import api from "@/plugins/api";
import { CONTACT_SUBJECT_TYPE } from "../../domain/subjectTypes";
const PSEUDONYMIZE = "Pseudonymize";
export async function submitRequest(subjectId) {
    const response = await api.post("/opconf-requests", { subjectType: CONTACT_SUBJECT_TYPE, subjectId, operation: PSEUDONYMIZE }, { unwrapEnvelope: true });
    return response.data;
}
export async function confirmRequest(requestId) {
    const response = await api.post(`/opconf-requests/${requestId}/confirm`, undefined, {
        unwrapEnvelope: true,
    });
    return response.data;
}
export async function cancelRequest(requestId) {
    const response = await api.post(`/opconf-requests/${requestId}/cancel`, undefined, {
        unwrapEnvelope: true,
    });
    return response.data;
}
export async function getRequest(requestId, signal) {
    const response = await api.get(`/opconf-requests/${requestId}`, { unwrapEnvelope: true, signal });
    return response.data;
}
